import React, { useRef, useState } from "react"
import { gql } from '@apollo/client'
import { Popover, PopoverBody } from "reactstrap"
import ConfirmationPopup from "../../Material/ConfirmationPopup"
import withApolloClient from '../../withApolloClient'

export const UpdateTaskMutation = gql`
    mutation updateTask($input: UpdateTaskMutationInput!) {
        updateTask(input: $input) {
        ok
        errors {
            messages
        }
        }
    }
    `


function TaskArchivePopover({ taskId, apolloClient, onArchived }) {
    const [openMenu, setOpenMenu] = useState("")
    const [openConfirm, setOpenConfirm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")

    const iconRef = useRef(null)

    const handleArchive = async () => {
        try {
            setLoading(true)
            setError("")
            setSuccess("")
            const queryInput = {
                taskId: taskId,
                isArchived: true,
            }

            const response = await apolloClient.mutate({
                mutation: UpdateTaskMutation,
                refetchQueries: ["AllTasks"],
                variables: { input: queryInput },
            })

            if (response?.data?.updateTask?.ok) {
                setSuccess("Task Archived Successfully")
                setOpenConfirm(false)
                setOpenMenu("")
                if (onArchived) onArchived()

            } else {
                setError(response.data.updateTask.errors?.messages?.join(", "))
            }

        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    return (

        <>
            <i ref={iconRef} className="fa fa-ellipsis-v" style={{ cursor: "pointer" }} onClick={() => setOpenMenu(openMenu === "taskArchieve" ? "" : "taskArchieve")} />
            <Popover trigger="legacy" placement="left" isOpen={openMenu === "taskArchieve"} target={iconRef.current}
                toggle={() => setOpenMenu("")} interaction={true}>
                <PopoverBody>
                    <div className="task-menu-options">
                        <div className="task-menu-item" style={{ cursor: "pointer" }} onClick={(e) => {
                            e.stopPropagation()
                            setOpenMenu("")
                            setOpenConfirm(true)
                        }}>
                            <i className="fa fa-archive mr-2" />Archive Task </div>
                    </div>
                </PopoverBody>
            </Popover>

            {/* Confirmation Popup */}
            <ConfirmationPopup
                open={openConfirm}
                message="Are you sure you want to archive this task?"
                loading={loading}
                handleClose={() => {
                    setOpenConfirm(false)
                    setSuccess("")
                    setError("")
                }}
                action="Yes"
                confirmAction={handleArchive}
                color="danger"
                error={error}
                success={success}
            />
        </>
    )
}

export default withApolloClient(TaskArchivePopover)
